/**
 * Brand color utilities for Chakra UI
 *
 * This file provides easy access to your semantic color tokens
 * while maintaining the subtle/base/bold naming convention.
 */

// Direct access to semantic color tokens
export const brandColors = {
  // Primary semantic tokens
  primary: {
    subtle: "primary-subtle",
    base: "primary-base",
    bold: "primary-bold",
  },

  // Interactive states
  primaryHover: "primary-hover",
  primaryActive: "primary-active",

  // On-color text variants
  onPrimary: {
    subtle: "on-primary-subtle",
    base: "on-primary-base",
    bold: "on-primary-bold",
  },
} as const;

// Helper function to get color values for use in CSS-in-JS
export const getBrandColor = (colorPath: string) => {
  // This will be resolved by Chakra UI's theme system
  return colorPath;
};

// Type-safe color token references
export type BrandColorToken =
  | "primary-subtle"
  | "primary-base"
  | "primary-bold"
  | "primary-hover"
  | "primary-active"
  | "on-primary-subtle"
  | "on-primary-base"
  | "on-primary-bold";

// Usage examples:
//
// In a component:
// <Box bg="primary-subtle" color="on-primary-subtle">
// <Button colorPalette="primary" variant="solid">
// <Button colorPalette="primary" variant="subtle">
// <Button colorPalette="primary" variant="bold">
//
// Or using the helper:
// <Box bg={getBrandColor(brandColors.primary.subtle)}>
